import React from 'react';
import { EditPage } from '@components/common';
import ConsumptionForm from '@components/common/forms/ConsumptionForm';

const ConsumptionEditPage = () => {
    return (
        <EditPage
            modelName="consumptions"
            FormComponent={ConsumptionForm}
        />
    );
};

export default ConsumptionEditPage;
